export const roles = {
    1: 'Root',
    2: 'Admin',
    3: 'Sales'
}
